<div fxLayout="column" >
<!--  <div fxLayout="row"-->
<!--       style="font-size: 22px; font-family: 'Century Gothic', sans-serif; color: var(&#45;&#45;primary);-->
<!--        letter-spacing: -0.02rem; margin-bottom:40px;">-->
<!--    Ιστορικό δηλώσεων-->
<!--  </div>-->

  <div fxShow.gt-sm fxFlex fxHide.lt-md style="min-height: 350px;">
    <div fxHide.lt-md fxShow.gt-sm style="margin-top:15px;" class="mat-elevation-z0">
      <mat-table *ngIf="consents.data.length > 0" style="width: 100%; font-family: 'Century Gothic', sans-serif" [dataSource]="consents" >
        <ng-container matColumnDef="position">
          <mat-header-cell  *matHeaderCellDef  fxLayoutAlign="start center center">AA</mat-header-cell>
          <mat-cell  *matCellDef="let consent" class="consentTitle"
                     fxLayoutAlign="start center center"> {{consent.position}} </mat-cell>
        </ng-container>


        <ng-container matColumnDef="formTitle">
          <mat-header-cell fxFlex="40"  *matHeaderCellDef  fxLayoutAlign="start center center"> Δήλωση</mat-header-cell>
          <mat-cell fxFlex="40"  *matCellDef="let consent" class="consentTitle"
                     fxLayoutAlign="start center center"> <label [matTooltip]="consent.formTitle"> {{ consent.formTitle | slice:0:80 }}{{consent.formTitle.length > 80 ? '...' : ''}} </label> </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell  *matHeaderCellDef  fxLayoutAlign="center center center">Κατάσταση</mat-header-cell>
          <mat-cell  *matCellDef="let consent"  fxLayoutAlign="center center center">
            <div class="statusButton"
                 [ngStyle]="{'background-color': commonService.getButtonColor(+consent.status)}"
                 fxLayoutAlign="center center center">{{+consent.status === 1 ? 'Αποδοχή' : +consent.status === -1 ? 'Σε Αναμονή' : 'Απόρριψη'}}</div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="displayName">
          <mat-header-cell fxFlex="15"  *matHeaderCellDef  fxLayoutAlign="center center center">Ονοματεπώνυμο</mat-header-cell>
          <mat-cell fxFlex="15"  *matCellDef="let consent"
                     fxLayoutAlign="center center center"> {{consent.displayName}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="modified_by">
          <mat-header-cell fxFlex="15"  *matHeaderCellDef  fxLayoutAlign="center center center">Ενημερώθηκε από</mat-header-cell>
          <mat-cell fxFlex="15"  *matCellDef="let consent"
                     fxLayoutAlign="center center center"> {{consent.modified_by}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="consentDate">
          <mat-header-cell  *matHeaderCellDef fxLayoutAlign="center center center">Ημ.
            Συναίνεσης
          </mat-header-cell>
          <mat-cell  *matCellDef="let consent"
                     fxLayoutAlign="center center center"> {{consent.consentDate}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell  *matHeaderCellDef fxLayoutAlign="center center center">Πλοήγηση</mat-header-cell>
          <mat-cell  *matCellDef="let consent"  fxLayoutAlign="center center center">
            <button *ngIf="!isNavigationToFormDisabled(consent)" mat-icon-button matTooltip="Πλοήγηση στη δήλωση"
                    [disabled]="isNavigationToFormDisabled(consent)" (click)="showCustomForm(consent)">
              <mat-icon style="align-content:center; vertical-align: middle; color:var(--secondaryBlue)">
                visibility
              </mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row  *matHeaderRowDef="columnsToDisplay; sticky: true"></mat-header-row>
        <mat-row  *matRowDef="let record; columns: columnsToDisplay"></mat-row>
      </mat-table>
      <div *ngIf="consents.data.length === 0" fxLayout="column" fxFlex style="height:300px" fxLayoutAlign="center center center">
        <img src="assets/images/noInfo2.png" style="width:150px; height:150px;" alt="noInfo"/>
        <div
          style="font-family: 'Century Gothic', sans-serif; font-weight: normal; font-size: 18px; margin-top:1em;">
          Δεν έχετε δηλώσεις
        </div>
      </div>
    </div>
<!--    <mat-tab-group>-->
<!--      <mat-tab>-->
<!--        <ng-template mat-tab-label>-->
<!--          <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">-->
<!--            Kατάσταση συναινέσεων-->
<!--          </div>-->
<!--        </ng-template>-->
<!--        &lt;!&ndash; Large Screen Table&ndash;&gt;-->
<!--        <div fxHide.lt-md fxShow.gt-sm style="margin-top:15px;" class="mat-elevation-z0">-->
<!--          <mat-table *ngIf="consents.data.length > 0" style="width: 100%; font-family: 'Century Gothic', sans-serif" [dataSource]="consents" >-->
<!--            <ng-container matColumnDef="position">-->
<!--              <mat-header-cell  *matHeaderCellDef  fxLayoutAlign="start center center">AA</mat-header-cell>-->
<!--              <mat-cell  *matCellDef="let consent" class="consentTitle"-->
<!--                  fxLayoutAlign="start center center"> {{consent.position}} </mat-cell>-->
<!--            </ng-container>-->


<!--            <ng-container matColumnDef="formTitle">-->
<!--              <mat-header-cell  *matHeaderCellDef  fxLayoutAlign="start center center"> Δήλωση</mat-header-cell>-->
<!--              <mat-cell  *matCellDef="let consent" class="consentTitle"-->
<!--                         fxLayoutAlign="start center center"> <label [matTooltip]="consent.formTitle"> {{ consent.formTitle | slice:0:80 }}{{consent.formTitle.length > 80 ? '...' : ''}} </label> </mat-cell>-->
<!--            </ng-container>-->

<!--            <ng-container matColumnDef="status">-->
<!--              <mat-header-cell  *matHeaderCellDef  fxLayoutAlign="center center center">Κατάσταση</mat-header-cell>-->
<!--              <mat-cell  *matCellDef="let consent"  fxLayoutAlign="center center center">-->
<!--                <div class="statusButton"-->
<!--                     [ngStyle]="{'background-color': commonService.getButtonColor(+consent.status)}"-->
<!--                     fxLayoutAlign="center center center">{{+consent.status === 1 ? 'Αποδοχή' : +consent.status === -1 ? 'Σε Αναμονή' : 'Απόρριψη'}}</div>-->
<!--              </mat-cell>-->
<!--            </ng-container>-->

<!--            <ng-container matColumnDef="displayName">-->
<!--              <mat-header-cell  *matHeaderCellDef  fxLayoutAlign="center center center">Ονοματεπώνυμο</mat-header-cell>-->
<!--              <mat-cell  *matCellDef="let consent"-->
<!--                  fxLayoutAlign="center center center"> {{consent.displayName}} </mat-cell>-->
<!--            </ng-container>-->

<!--            <ng-container matColumnDef="modified_by">-->
<!--              <mat-header-cell  *matHeaderCellDef  fxLayoutAlign="center center center">Ενημερώθηκε από</mat-header-cell>-->
<!--              <mat-cell  *matCellDef="let consent"-->
<!--                         fxLayoutAlign="center center center"> {{consent.modified_by}} </mat-cell>-->
<!--            </ng-container>-->

<!--            <ng-container matColumnDef="consentDate">-->
<!--              <mat-header-cell  *matHeaderCellDef fxLayoutAlign="center center center">Ημ.-->
<!--                Συναίνεσης-->
<!--              </mat-header-cell>-->
<!--              <mat-cell  *matCellDef="let consent"-->
<!--                  fxLayoutAlign="center center center"> {{consent.consentDate}} </mat-cell>-->
<!--            </ng-container>-->

<!--            <ng-container matColumnDef="actions">-->
<!--              <mat-header-cell  *matHeaderCellDef fxLayoutAlign="center center center">Πλοήγηση</mat-header-cell>-->
<!--              <mat-cell  *matCellDef="let consent"  fxLayoutAlign="center center center">-->
<!--                <button *ngIf="!isNavigationToFormDisabled(consent)" mat-icon-button matTooltip="Πλοήγηση στη δήλωση"-->
<!--                        [disabled]="isNavigationToFormDisabled(consent)" (click)="showCustomForm(consent)">-->
<!--                  <mat-icon style="align-content:center; vertical-align: middle; color:var(&#45;&#45;secondaryBlue)">-->
<!--                    visibility-->
<!--                  </mat-icon>-->
<!--                </button>-->
<!--              </mat-cell>-->
<!--            </ng-container>-->

<!--            <mat-header-row  *matHeaderRowDef="columnsToDisplay; sticky: true"></mat-header-row>-->
<!--            <mat-row  *matRowDef="let record; columns: columnsToDisplay"></mat-row>-->
<!--          </mat-table>-->
<!--          <div *ngIf="consents.data.length === 0" fxLayout="column" fxFlex style="height:300px" fxLayoutAlign="center center center">-->
<!--            <img src="assets/images/noInfo2.png" style="width:150px; height:150px;" alt="noInfo"/>-->
<!--            <div-->
<!--              style="font-family: 'Century Gothic', sans-serif; font-weight: normal; font-size: 18px; margin-top:1em;">-->
<!--              Δεν έχετε δηλώσεις-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--&lt;!&ndash;        <div *ngIf="consents.data.length === 0" fxLayout="column" class="card" style="height:450px;" fxFlex>&ndash;&gt;-->

<!--&lt;!&ndash;          <div style="margin-top:50px; margin-left:auto; margin-right:auto;">&ndash;&gt;-->
<!--&lt;!&ndash;            <img src="assets/images/noInfo2.png" style="width:150px; height:150px;" alt="noInfo"/>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;          <div&ndash;&gt;-->
<!--&lt;!&ndash;            style="font-family: 'Century Gothic', 'Helvetica Neue', sans-serif; font-weight: normal; font-size: 18px; margin-left:auto; margin-right:auto;">&ndash;&gt;-->
<!--&lt;!&ndash;            Δεν εχετε εκκρεμείς αιτήσεις&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->

<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--        &lt;!&ndash; &ndash;&gt;-->

<!--      </mat-tab>-->
<!--&lt;!&ndash;      <mat-tab>&ndash;&gt;-->
<!--&lt;!&ndash;        <ng-template mat-tab-label>&ndash;&gt;-->
<!--&lt;!&ndash;          <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">&ndash;&gt;-->
<!--&lt;!&ndash;            Kατάσταση εγγραφών&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;        </ng-template>&ndash;&gt;-->
<!--&lt;!&ndash;        <div fxHide.lt-md fxShow.gt-sm style="margin-top:15px;" class="mat-elevation-z0">&ndash;&gt;-->
<!--&lt;!&ndash;        <app-my-affirmations [user]="user"></app-my-affirmations>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;      </mat-tab>&ndash;&gt;-->

<!--&lt;!&ndash;      <mat-tab>&ndash;&gt;-->
<!--&lt;!&ndash;        <ng-template mat-tab-label>&ndash;&gt;-->
<!--&lt;!&ndash;          <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">&ndash;&gt;-->
<!--&lt;!&ndash;            Ιστορικό συναινέσεων&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;        </ng-template>&ndash;&gt;-->
<!--&lt;!&ndash;        <div *ngFor="let consent of consentsHistory"&ndash;&gt;-->
<!--&lt;!&ndash;             style="margin-top:50px; padding-left:15px; padding-right:15px; padding-bottom:15px;">&ndash;&gt;-->

<!--&lt;!&ndash;          <div fxLayout="column" class="container">&ndash;&gt;-->

<!--&lt;!&ndash;            <div fxLayout="row" class="dateSection">{{getDate(consent.action_date)}}</div>&ndash;&gt;-->

<!--&lt;!&ndash;            <div fxLayout="column" style="width:50px;" fxLayoutAlign="center center center">&ndash;&gt;-->
<!--&lt;!&ndash;              <div fxLayoutAlign="center center center" class="verticalSeparator"></div>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->

<!--&lt;!&ndash;            <div fxLayout="column" class="consentContainer mat-elevation-z10">&ndash;&gt;-->

<!--&lt;!&ndash;              <div fxLayout="row" fxLayoutGap="5px">&ndash;&gt;-->
<!--&lt;!&ndash;                <div fxFlex="20" class="timeSection">{{getTime(consent.action_date)}}</div>&ndash;&gt;-->
<!--&lt;!&ndash;                <div fxFlex="80" class="statusSection" style="font-family: 'Century Gothic', sans-serif"> Ο γονέας {{consent.modified_by_displayName}}&ndash;&gt;-->
<!--&lt;!&ndash;                  {{+consent.value === 1 ? 'αποδέχτηκε' : +consent.value === -1 ? 'Σε Αναμονή' : 'απέρριψε'}} την&ndash;&gt;-->
<!--&lt;!&ndash;                  παρακάτω ερώτηση για τον/την <b><u>{{consent.childDisplayName}}</u></b> :&ndash;&gt;-->
<!--&lt;!&ndash;                  <b>{{consent.consentDescription}}</b>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->

<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--&lt;!&ndash;              <div fxLayout="row" style="margin-top:20px;" fxLayoutGap="5px">&ndash;&gt;-->
<!--&lt;!&ndash;                <div fxFlex="20">&ndash;&gt;-->
<!--&lt;!&ndash;                  <div class="imageSection" fxLayoutAlign="center center center">&ndash;&gt;-->
<!--&lt;!&ndash;                    <div fxLayoutAlign="center center center" fxFlexAlign="center center center">&ndash;&gt;-->
<!--&lt;!&ndash;                      <mat-icon *ngIf="+consent.value === 1" style="color:green">done</mat-icon>&ndash;&gt;-->
<!--&lt;!&ndash;                      <mat-icon *ngIf="+consent.value === 0" style="color:red">close</mat-icon>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                  </div>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->

<!--&lt;!&ndash;                <div fxFlex="80" fxFlexAlign="center" style="font-family: 'Century Gothic', sans-serif">&ndash;&gt;-->
<!--&lt;!&ndash;                  Για να αλλάξετε την επιλογή της συναίνεσής σας πατήστε <a (click)="showConsent(consent)">ΕΔΩ</a>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->

<!--&lt;!&ndash;            </div>&ndash;&gt;-->

<!--&lt;!&ndash;          </div>&ndash;&gt;-->

<!--&lt;!&ndash;        </div>&ndash;&gt;-->

<!--&lt;!&ndash;        <div *ngIf="consentsHistory.length === 0 && !historyLoading" fxLayout="column" fxFlex style="height:300px" fxLayoutAlign="center center center">&ndash;&gt;-->
<!--&lt;!&ndash;          <img src="assets/images/noInfo2.png" style="width:150px; height:150px;" alt="noInfo"/>&ndash;&gt;-->
<!--&lt;!&ndash;          <div&ndash;&gt;-->
<!--&lt;!&ndash;            style="font-family: 'Century Gothic', sans-serif; font-weight: normal; font-size: 18px; margin-top:1em;">&ndash;&gt;-->
<!--&lt;!&ndash;            Δεν υπάρχει ιστορικό&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;        <div *ngIf="historyLoading">&ndash;&gt;-->
<!--&lt;!&ndash;          <app-loading></app-loading>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;      </mat-tab>&ndash;&gt;-->


<!--&lt;!&ndash;      <mat-tab>&ndash;&gt;-->
<!--&lt;!&ndash;        <ng-template mat-tab-label>&ndash;&gt;-->
<!--&lt;!&ndash;          <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">&ndash;&gt;-->
<!--&lt;!&ndash;            Ιστορικό εγγραφών&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;        </ng-template>&ndash;&gt;-->
<!--&lt;!&ndash;        <div *ngFor="let consent of affirmationsHistory"&ndash;&gt;-->
<!--&lt;!&ndash;             style="margin-top:50px; padding-left:15px; padding-right:15px; padding-bottom:15px;">&ndash;&gt;-->

<!--&lt;!&ndash;          <div fxLayout="column" class="container">&ndash;&gt;-->

<!--&lt;!&ndash;            <div fxLayout="row" class="dateSection">{{getDate(consent.action_date)}}</div>&ndash;&gt;-->

<!--&lt;!&ndash;            <div fxLayout="column" style="width:50px;" fxLayoutAlign="center center center">&ndash;&gt;-->
<!--&lt;!&ndash;              <div fxLayoutAlign="center center center" class="verticalSeparator"></div>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->

<!--&lt;!&ndash;            <div fxLayout="column" class="consentContainer mat-elevation-z10">&ndash;&gt;-->

<!--&lt;!&ndash;              <div fxLayout="row" fxLayoutGap="5px">&ndash;&gt;-->
<!--&lt;!&ndash;                <div fxFlex="20" class="timeSection">{{getTime(consent.action_date)}}</div>&ndash;&gt;-->
<!--&lt;!&ndash;                <div fxFlex="80" class="statusSection" style="font-family: 'Century Gothic', sans-serif"> Ο γονέας {{consent.modified_by_displayName}}&ndash;&gt;-->
<!--&lt;!&ndash;                  {{+consent.value === 1 ? 'ολοκλήρωσε την εγγραφή' : 'Σε Αναμονή'}} του/της&ndash;&gt;-->
<!--&lt;!&ndash;                  <b><u>{{consent.childDisplayName}}</u></b>&ndash;&gt;-->
<!--&lt;!&ndash;                  στην δραστηριότητα <b>{{consent.description}}</b>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->

<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--&lt;!&ndash;              <div fxLayout="row" style="margin-top:20px;" fxLayoutGap="5px">&ndash;&gt;-->
<!--&lt;!&ndash;                <div fxFlex="20">&ndash;&gt;-->
<!--&lt;!&ndash;                  <div class="imageSection" fxLayoutAlign="center center center">&ndash;&gt;-->
<!--&lt;!&ndash;                    <div fxLayoutAlign="center center center" fxFlexAlign="center center center">&ndash;&gt;-->
<!--&lt;!&ndash;                      <mat-icon *ngIf="+consent.value === 1" style="color:green">done</mat-icon>&ndash;&gt;-->
<!--&lt;!&ndash;                      <mat-icon *ngIf="+consent.value === 0" style="color:red">close</mat-icon>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                  </div>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->

<!--&lt;!&ndash;&lt;!&ndash;                <div fxFlex="80" fxFlexAlign="center" style="font-family: 'Century Gothic', sans-serif">&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;                  Για να αλλάξετε την επιλογή της συναίνεσής σας πατήστε <a (click)="showConsent(consent)">ΕΔΩ</a>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;                </div>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->

<!--&lt;!&ndash;            </div>&ndash;&gt;-->

<!--&lt;!&ndash;          </div>&ndash;&gt;-->

<!--&lt;!&ndash;        </div>&ndash;&gt;-->

<!--&lt;!&ndash;        <div *ngIf="consentsHistory.length === 0 && !historyLoading" fxLayout="column" fxFlex style="height:300px" fxLayoutAlign="center center center">&ndash;&gt;-->
<!--&lt;!&ndash;          <img src="assets/images/noInfo2.png" style="width:150px; height:150px;" alt="noInfo"/>&ndash;&gt;-->
<!--&lt;!&ndash;          <div&ndash;&gt;-->
<!--&lt;!&ndash;                  style="font-family: 'Century Gothic', sans-serif; font-weight: normal; font-size: 18px; margin-top:1em;">&ndash;&gt;-->
<!--&lt;!&ndash;            Δεν υπάρχει ιστορικό&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;        <div *ngIf="historyLoading">&ndash;&gt;-->
<!--&lt;!&ndash;          <app-loading></app-loading>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;      </mat-tab>&ndash;&gt;-->
<!--    </mat-tab-group>-->
  </div>


  <div fxShow.lt-md fxHide.gt-sm style="margin-bottom: 0px;">
    <div fxLayout="column" fxShow.lt-md fxHide.gt-sm style="margin-top: 0px; padding: 0; background-color: white; position: -webkit-sticky; z-index: 9; position: sticky; top: 0px;">
      <div fxLayout="row" fxFlex="grow" style="background-color: white;">
        <mat-form-field appearance="legacy" style="width:100%; padding:10px; background-color: white;">
          <mat-label>Επιλέξτε κατηγορία</mat-label>
          <mat-select [(ngModel)]="selectedOption" (selectionChange)="render()">
            <mat-option *ngFor="let option of options" [value]="option">
              {{option.label}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div fxShow.lt-md fxHide.gt-sm fxLayout="column" fxLayoutAlign="center center center" class="cardsContainer">
      {{render()}}
      <!-- Small Screen Cards-->
      <mat-card class="smallCard  mat-elevation-z9" *ngFor="let consent of displayCards">

        <mat-card-content>
          <div *ngIf="selectedOption.id === 1" fxLayout="column" class="smallCard">

            <div fxLayout="row" class="headerSection">Δήλωση</div>
            <div fxLayout="row">{{consent.title}}</div>

            <div fxLayout="row" class="headerSection" fxLayoutAlign="start center center">Κατάσταση &nbsp;
              <div class="statusButton" [ngStyle]="{'background-color': commonService.getButtonColor(+consent.status)}"
                   fxLayoutAlign="center center center">{{+consent.status === 1 ? 'Συμπληρώθηκε' : +consent.status === -1 ? 'Σε Αναμονή' : 'Απόρριψη'}}</div>
            </div>

            <div fxLayout="row" class="headerSection">Ονοματεπώνυμο</div>
            <div fxLayout="row">{{consent.displayName}}</div>
            <div fxLayout="row" class="headerSection">Ενημερώθηκε από</div>
            <div fxLayout="row">{{consent.modified_by_displayName}}</div>
            <div fxLayout="row" class="headerSection">Ημερομηνία Συναίνεσης</div>
            <div fxLayout="row">{{consent.modified_at}}</div>
          </div>
          <div *ngIf="selectedOption.id === 2" fxLayout="column" class="smallCard">

            <div fxLayout="row" class="headerSection">Δήλωση</div>
            <div fxLayout="row">{{consent.formTitle}}</div>

            <div fxLayout="row" class="headerSection">Ερώτηση</div>
            <div fxLayout="row" class="header">{{consent.consent? consent.consent : consent.title}}</div>


            <div fxLayout="row" class="headerSection" fxLayoutAlign="start center center">Κατάσταση &nbsp;
              <div class="statusButton" [ngStyle]="{'background-color': commonService.getButtonColor(+consent.status)}"
                   fxLayoutAlign="center center center">{{+consent.status === 1 ? 'Αποδοχή' : +consent.status === -1 ? 'Σε Αναμονή' : 'Απόρριψη'}}</div>
            </div>

            <div fxLayout="row" class="headerSection">Ονοματεπώνυμο</div>
            <div fxLayout="row">{{consent.displayName}}</div>
            <div fxLayout="row" class="headerSection">Ημερομηνία Συναίνεσης</div>
            <div fxLayout="row">{{consent.consentDate}}</div>
          </div>
          <div *ngIf="selectedOption.id === 3" fxLayout="column" class="smallCard">

            <div fxLayout="row" class="headerSection">Δήλωση</div>
            <div fxLayout="row">{{consent.formTitle}}</div>

            <div fxLayout="row" class="headerSection">Ερώτηση</div>
            <div fxLayout="row" class="header">{{consent.consent? consent.consent : consent.title}}</div>


            <div fxLayout="row" class="headerSection" fxLayoutAlign="start center center">Κατάσταση &nbsp;
              <div class="statusButton" [ngStyle]="{'background-color': commonService.getButtonColor(+consent.status)}"
                   fxLayoutAlign="center center center">{{+consent.status === 1 ? 'Αποδοχή' : +consent.status === -1 ? 'Σε Αναμονή' : 'Απόρριψη'}}</div>
            </div>

            <div fxLayout="row" class="headerSection">Ονοματεπώνυμο</div>
            <div fxLayout="row">{{consent.displayName}}</div>
            <div fxLayout="row" class="headerSection">Ημερομηνία Συναίνεσης</div>
            <div fxLayout="row">{{consent.consentDate}}</div>
          </div>
          <div *ngIf="selectedOption.id === 4" fxLayout="column" class="smallCard">

            <div fxLayout="row" class="headerSection">Δήλωση</div>
            <div fxLayout="row">{{consent.formTitle}}</div>

            <div fxLayout="row" class="headerSection">Ερώτηση</div>
            <div fxLayout="row" class="header">{{consent.consent? consent.consent : consent.title}}</div>


            <div fxLayout="row" class="headerSection" fxLayoutAlign="start center center">Κατάσταση &nbsp;
              <div class="statusButton" [ngStyle]="{'background-color': commonService.getButtonColor(+consent.status)}"
                   fxLayoutAlign="center center center">{{+consent.status === 1 ? 'Αποδοχή' : +consent.status === -1 ? 'Σε Αναμονή' : 'Απόρριψη'}}</div>
            </div>

            <div fxLayout="row" class="headerSection">Ονοματεπώνυμο</div>
            <div fxLayout="row">{{consent.displayName}}</div>
            <div fxLayout="row" class="headerSection">Ημερομηνία Συναίνεσης</div>
            <div fxLayout="row">{{consent.consentDate}}</div>
          </div>
        </mat-card-content>
        <mat-card-actions align="center">
          <button mat-flat-button color="primary" style="width: 100%;" [disabled]="isNavigationToFormDisabled(consent)" (click)="showConsent(consent)">Πλοήγηση στη φόρμα
          </button>
        </mat-card-actions>
      </mat-card>
      <!-- -->
    </div>
  </div>
</div>
